import { Segmented } from "./ui";

export type GroupBy = "stage" | "step" | "month" | "tier" | "none";

export function PipelineGrouping({ phone, preview, group, onChange }: {
  phone: boolean;
  preview: boolean;
  group: GroupBy;
  onChange: (group: GroupBy) => void;
}) {
  if (phone) {
    const options: { value: GroupBy; label: string; title?: string }[] = [
      { value: "stage", label: "By stage" },
      ...(preview ? [{ value: "step" as const, label: "By step", title: "Preview: grouped by loan step" }] : []),
    ];
    // Saved views and desktop resizing can leave the phone in another grouping.
    if (group === "month" || group === "tier" || group === "none") {
      options.push({ value: group, label: { month: "By month", tier: "By tier", none: "None" }[group] });
    }
    return options.length > 1 ? <Segmented label="Group active deals" size="lg" value={group} onChange={onChange} options={options} /> : null;
  }

  return (
    <label className="flex items-center gap-1.5 text-[13px] text-ink-2">
      Group
      <select value={group} onChange={(e) => onChange(e.target.value as GroupBy)} className="focus-ring h-8 rounded-md border border-input bg-surface px-2 text-[13px] text-ink">
        <option value="stage">Stage</option>
        {preview ? <option value="step">Step · Preview</option> : null}
        <option value="month">Month</option>
        <option value="tier">Tier</option>
        <option value="none">None</option>
      </select>
    </label>
  );
}
